module.exports = __webpack_public_path__ + "img/_0007_图层-9.8bfdc6af.png";